import isFunction from 'lodash/isFunction.js';

var script = {
  name: 'TableRow',
  inject: ['$table'],
  props: {
    index: {
      type: Number,
      required: true
    },
    row: {
      type: Object,
      required: true
    }
  },
  computed: {
    isTreeExpanded() {
      return Boolean(this.$table.treeExpandedMap[this.row[this.$table.rowKey]]);
    },
    isChild() {
      return Boolean(this.$table.treeExpandedChildMap[this.row[this.$table.rowKey]]);
    },
    isActive() {
      return this.row[this.$table.rowKey] === this.$table.activeRow;
    },
    isSelected() {
      return Boolean(this.$table.selectedMap[this.row[this.$table.rowKey]]);
    },
    isGroupRow() {
      return this.row.isGroup;
    },
    isExpandableGroupRow() {
      return this.isGroupRow && this.$table.groupConfig.expandable;
    },
    rowClassName() {
      if (this.$table.rowClassName) {
        return isFunction(this.$table.rowClassName) ? this.$table.rowClassName({
          row: this.row,
          rowIndex: this.index
        }) : this.$table.rowClassName;
      }
      return '';
    }
  }
};

export { script as default };
//# sourceMappingURL=table-row.vue2.js.map
